import React from "react";

function InlineErrors({ text }) {
  return <span style={{ color: "#ae5856", fontWeight: "bold" }}>{text}</span>;
}

export default InlineErrors;
